import { createFileRoute } from '@tanstack/react-router';
import CandidateMailsTemplate from '@/features/agent/candidate_mails/templates/CandidateMailsTemplate';
import {
  candidateMailFolders,
  type CandidateMailFolder,
} from '@/features/agent/candidate_mails/constants';

type CandidateMailsSearch = {
  folder?: CandidateMailFolder;
  mailId?: number;
  templateId?: number;
};

const toPositiveInteger = (value: unknown) => {
  const number = Number(value);
  return Number.isInteger(number) && number > 0 ? number : undefined;
};

export const Route = createFileRoute('/agent/candidate_mails/')({
  component: RouteComponent,
  staticData: { title: 'メール管理' },
  validateSearch: (search: Record<string, unknown>): CandidateMailsSearch => ({
    folder: candidateMailFolders.includes(search.folder as CandidateMailFolder)
      ? (search.folder as CandidateMailFolder)
      : undefined,
    mailId: toPositiveInteger(search.mailId),
    templateId: toPositiveInteger(search.templateId),
  }),
});

function RouteComponent() {
  const { folder, mailId, templateId } = Route.useSearch();
  return (
    <CandidateMailsTemplate folder={folder ?? 'sent'} mailId={mailId} templateId={templateId} />
  );
}
